// import React, { useEffect, useState } from 'react'
// import styles from './style.module.scss'
// import Navbar from '../../Components/Navbar'
// import { Helmet } from 'react-helmet'
// import ImageDisplay from '../../Components/ImageDisplay'
// import Copyrights from '../../Components/Copyrights'

// import gallery1 from '../../Assets/gallery/1-5.jpg'
// import gallery2 from '../../Assets/gallery/2-2.jpg'
// import gallery3 from '../../Assets/gallery/2-1-1.jpg'
// import gallery4 from '../../Assets/gallery/z-1.jpg'
// import gallery5 from '../../Assets/gallery/z-2.jpg'
// import gallery6 from '../../Assets/gallery/DSC_0220.jpg'
// import gallery7 from '../../Assets/gallery/DSC_0236.jpg'
// import gallery8 from '../../Assets/gallery/DSC_0207.jpg'
// import gallery9 from '../../Assets/gallery/DSC_0209.jpg'
// import gallery10 from '../../Assets/gallery/DSC_0205.jpg'
// import gallery11 from '../../Assets/gallery/DSC_0206.jpg'
// import gallery12 from '../../Assets/gallery/DSC_0195.jpg'
// import gallery13 from '../../Assets/gallery/z-3.jpg'
// import gallery14 from '../../Assets/gallery/DSC_0194.jpg'
// import gallery15 from '../../Assets/gallery/DSC_0186.jpg'
// import gallery16 from '../../Assets/gallery/DSC_0193.jpg'
// import gallery17 from '../../Assets/gallery/DSC_0183.jpg'
// import gallery18 from '../../Assets/gallery/DSC_0182.jpg'
// import gallery19 from '../../Assets/gallery/3-5.jpg'
// import gallery20 from '../../Assets/gallery/3-4.jpg'
// import gallery21 from '../../Assets/gallery/3-2.jpg'
// import gallery22 from '../../Assets/gallery/3-3.jpg'
// import gallery23 from '../../Assets/gallery/z2.jpg'
// import gallery24 from '../../Assets/gallery/2-3.jpg'
// import gallery25 from '../../Assets/gallery/3-1.jpg'

// const GalleryPage = () => {

//   const [selectedImage, setSelectedImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const images = [
//     gallery1,
//     gallery2,
//     gallery3,
//     gallery4,
//     gallery5,
//     gallery6,
//     gallery7,
//     gallery8,
//     gallery9,
//     gallery10,
//     gallery11,
//     gallery12,
//     gallery13,
//     gallery14,
//     gallery15,
//     gallery16,
//     gallery17,
//     gallery18,
//     gallery19,
//     gallery20,
//     gallery21,
//     gallery22,
//     gallery23,
//     gallery24,
//     gallery25,
//   ]

//   // useEffect(() => {
//   //   const imgElements = document.querySelectorAll('img');
//   //   imgElements.forEach(img => {
//   //     console.log('Adding event listener to image');
//   //     img.addEventListener('click', (e) => {
//   //       console.log('current img index', currentIndex);
//   //       setSelectedImage(e.target.src)
//   //       setCurrentIndex(images.indexOf(e.target.src));
//   //       console.log('img index changed to', currentIndex);
//   //     });
//   //   });
//   // }, []);

//   useEffect(() => {
//     if (selectedImage) {
//       const newIndex = images.indexOf(selectedImage);
//       setCurrentIndex(newIndex);
//     }
//   }, [selectedImage]);


//   const handleClose = () => {
//     setSelectedImage(null);
//     setCurrentIndex(0);
//   };

//   const handleNext = () => {
//     const nextImage = images[currentIndex + 1];
//     if (nextImage) {
//       setSelectedImage(nextImage);
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const handlePrevious = () => {
//     const previousImage = images[currentIndex - 1];
//     if (previousImage) {
//       setSelectedImage(previousImage);
//       setCurrentIndex(currentIndex - 1);
//     }
//   };


//   return (
//     <div className={styles.container}>
//       <Helmet>
//         <title>Gallery</title>
//       </Helmet>
//       <Navbar active="gallery" />
//       {selectedImage && (
//         <ImageDisplay
//           image={selectedImage}
//           onClose={handleClose}
//           onNext={handleNext}
//           onPrevious={handlePrevious}
//         />
//       )}
//       <div className={styles.galleryGrid}>
//         {images.map((image, index) => (
//           <img key={index} src={image} alt={`Gallery Image ${index + 1}`} onClick={() => { setSelectedImage(image); setCurrentIndex(index) }} />
//         ))}
//       </div>
//       <Copyrights />
//     </div>
//   )
// }

// export default GalleryPage


import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'
import ImageDisplay from '../../Components/ImageDisplay'
import Copyrights from '../../Components/Copyrights'

import gallery1 from '../../Assets/gallery/1-5.jpg'
import gallery2 from '../../Assets/gallery/2-2.jpg'
import gallery3 from '../../Assets/gallery/2-1-1.jpg'
import gallery4 from '../../Assets/gallery/z-1.jpg'
import gallery5 from '../../Assets/gallery/z-2.jpg'
import gallery6 from '../../Assets/gallery/DSC_0220.jpg'
import gallery7 from '../../Assets/gallery/DSC_0236.jpg'
import gallery8 from '../../Assets/gallery/DSC_0207.jpg'
import gallery9 from '../../Assets/gallery/DSC_0209.jpg'
import gallery10 from '../../Assets/gallery/DSC_0205.jpg'
import gallery11 from '../../Assets/gallery/DSC_0206.jpg'
import gallery12 from '../../Assets/gallery/DSC_0195.jpg'
import gallery13 from '../../Assets/gallery/z-3.jpg'
import gallery14 from '../../Assets/gallery/DSC_0194.jpg'
import gallery15 from '../../Assets/gallery/DSC_0186.jpg'
import gallery16 from '../../Assets/gallery/DSC_0193.jpg'
import gallery17 from '../../Assets/gallery/DSC_0183.jpg'
import gallery18 from '../../Assets/gallery/DSC_0182.jpg'
import gallery19 from '../../Assets/gallery/3-5.jpg'
import gallery20 from '../../Assets/gallery/3-4.jpg'
import gallery21 from '../../Assets/gallery/3-2.jpg'
import gallery22 from '../../Assets/gallery/3-3.jpg'
import gallery23 from '../../Assets/gallery/z2.jpg'
import gallery24 from '../../Assets/gallery/2-3.jpg'
import gallery25 from '../../Assets/gallery/3-1.jpg'
import Aos from 'aos'
import 'aos/dist/aos.css';

const GalleryPage = () => {

  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const [imagesLoaded, setImagesLoaded] = useState(false);

  const images = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
    gallery23,
    gallery24,
    gallery25,
  ];

  // const handleImageClick = (index) => {
  //   setSelectedImage(images[index]);
  //   setCurrentIndex(index);
  // };

  // const handleClose = () => {
  //   setSelectedImage(null);
  //   setCurrentIndex(null);
  // };

  // const handleNext = () => {
  //   if (currentIndex !== null) {
  //     const nextIndex = (currentIndex + 1) % images.length;
  //     setSelectedImage(images[nextIndex]);
  //     setCurrentIndex(nextIndex);
  //   }
  // };

  // const handlePrevious = () => {
  //   if (currentIndex !== null) {
  //     const prevIndex = (currentIndex - 1 + images.length) % images.length;
  //     setSelectedImage(images[prevIndex]);
  //     setCurrentIndex(prevIndex);
  //   }
  // };

  const handleImageClick = (index) => {
    // Reset selected image and index when a new image is clicked
    setSelectedImage(images[index]);
    setCurrentIndex(index);
  };

  const handleClose = () => {
    // setTimeout(() => {
    setSelectedImage(null);
    setCurrentIndex(null);
    // }, 300);
  };

  const handleNext = () => {
    if (currentIndex !== null) {
      const nextIndex = (currentIndex + 1) % images.length;
      setSelectedImage(images[nextIndex]); // Ensure state sync
      setCurrentIndex(nextIndex);
    }
  };

  const handlePrevious = () => {
    if (currentIndex !== null) {
      const prevIndex = (currentIndex - 1 + images.length) % images.length;
      setSelectedImage(images[prevIndex]); // Ensure state sync
      setCurrentIndex(prevIndex);
    }
  };

  useEffect(() => {
    Aos.init({ duration: 1000 });
    // Aos.refresh();
  }, []);


  useEffect(() => {
    const handleImagesLoaded = () => {
      setImagesLoaded(true);
    };

    if (imagesLoaded) {
      Aos.refresh();
    }

    return () => {
      window.removeEventListener('load', handleImagesLoaded);
    };
  }, [imagesLoaded]);

  useEffect(() => {
    const handleImagesLoaded = () => {
      setImagesLoaded(true);
      console.log('Images loaded');
    };

    window.addEventListener('load', handleImagesLoaded);

    return () => {
      window.removeEventListener('load', handleImagesLoaded);
    };
  }, []);


  return (
    <div className={styles.container}>
      <Helmet>
        <title>Gallery</title>
      </Helmet>
      <Navbar active="gallery" />
      {selectedImage && (
        <ImageDisplay
          image={selectedImage}
          onClose={handleClose}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      )}
      <div className={styles.galleryGrid}>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Gallery Image ${index + 1}`}
            onClick={() => handleImageClick(index)}
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
          />
        ))}
      </div>
      <Copyrights />
    </div>
  );
};

export default GalleryPage;